
import { useNavigate, useLocation } from 'react-router-dom';

// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    if (location.pathname === '/' && path === '/') {
      // Se já estiver na home, apenas rola para o topo
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(path);
    }
  };

  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <button
            onClick={() => handleNavigation('/')}
            className="flex items-center space-x-3 cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/261197e3c61643879bf9283aac305692.png"
              alt="JB PINTURAS"
              className="h-16 w-auto object-contain"
            />
          </button>

          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => handleNavigation('/')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => handleNavigation('/servicos')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Serviços
            </button>
            <button
              onClick={() => handleNavigation('/portfolio')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Portfólio
            </button>
            <button
              onClick={() => handleNavigation('/depoimentos')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Depoimentos
            </button>
            <button
              onClick={() => handleNavigation('/sobre')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Sobre Nós
            </button>
            <button
              onClick={() => handleNavigation('/contato')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              Contato
            </button>
          </nav>

          <a
            href="https://wa.me/5512981564801"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWhatsAppClick}
            className="hidden lg:flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-6 py-3 rounded-full font-bold hover:from-orange-600 hover:to-yellow-600 transition-all transform hover:scale-105 whitespace-nowrap shadow-lg cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>Atendimento</span>
          </a>

          <button className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors cursor-pointer">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`text-2xl ri-menu-line ${scrolled ? 'text-gray-800' : 'text-white'}`}></i>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
}
